import * as joda from "@js-joda/core";
import currency from "currency.js";
import h from "trader-hyperscript";
import { checkAllCasesHandled } from "trader.ts/utils";
import { connection } from "../../../connection";
import { getServerSetting } from "../../../serversetting";
import { get_next_reply_id } from "../../../sql/classy/emails";
import {
  get_enrollment_created_email,
  get_enrollment_for_invitation,
  get_enrollmentrequest_for_newenrreq,
  get_evaluation_for_email,
  get_expected_payment_for_reminder,
  get_file_note_for_email,
  get_lesson_for_absencerequest_email,
  get_lesson_for_replacement_email,
  get_message_for_email,
  get_student_charge_email,
  get_text_note_for_email,
  get_user_default_template_for_type,
} from "../../../sql/classy/emailtemplates";
import {
  get_invoice_for_periodfee,
  get_invoice_full,
} from "../../../sql/classy/invoices";
import { get_lessongroup_for_enrollment } from "../../../sql/classy/lessons";
import { find_note_reply } from "../../../sql/classy/notes";
import { getstudentsforenrollments } from "../../../sql/classy/students";
import {
  accountingsoftwarelink_software_tab,
  expected_payments,
  invoicedetails_address_tab,
  invoicedetails_extra_tab,
  invoicedetails_vat_tab,
  message_repliesformessages,
  message_templates,
  note_repliesfornotes,
  schoolaccount_tab,
  schoolname_schoolnamesetting_tab,
  schoolurl_tab,
  teacherscanplan_tab,
} from "../../../sql/classy/tables";
import {
  enrollmentid,
  enrollmentrequestid,
  evaluationid,
  expectedpaymentid,
  filenoteid,
  iban,
  invoiceid,
  lessonid,
  messageid,
  messagetemplateid,
  messagetemplatetype,
  periodic_payment_method,
  periodid,
  price_adapted_to_lg_and_student,
  replyid,
  student_charge_id,
  studentid,
  teacherid,
  textnoteid,
  waitinglistid,
  waitinglistlessongroupid,
} from "../../../sql/classy/types";
import {
  get_waitinglist_group_by_id,
  get_waitinglist_private_by_id,
} from "../../../sql/classy/waitinglist";
import { isNil } from "../../lib/istype";
import { promiseAllFromObject } from "../../lib/promise";
import { roundTo2 } from "../../lib/round";
import { makeHtmlFromTextNote } from "../../pages/notes/noteswidget";
import { getInvoiceDirectDebitInfoStatus } from "../../pages/student_direct_debit_mandates/getenrollmentdirectdebitstatus";
import {
  formulaType,
  parseFormulaType,
  parseWeekday,
} from "../../parsing_from_ur";
import {
  HHmm,
  ddMMMMyyyy,
  ddMMyyyy,
  renderCurrency,
  renderFirstNameLastName,
  renderFormulaTypeShort,
  renderInvoiceSubjectForStudentEmail,
  renderLessonLocation,
  renderTimeRangePlusWeekday,
} from "../../render";
import * as routes from "../../routes";
import { enrollment_requestRoute } from "../../routes";
import {
  getAlwaysShowWireInstructions,
  getElectronicPaymentsEnabled,
  stripHttpHttps,
} from "../../serversettings";
import { describePeriod, translateWeekday } from "../../translations_specific";
import { classyTsContext, schoolurl } from "../../types";
import { getInvoiceSubjects } from "../finance";
import { defaultTemplate_absenceRequested } from "./default_email_templates/absencerequested";
import { defaultTemplate_confirmEnrollmentRequest } from "./default_email_templates/confirmenrollmentrequest";
import { defaultTemplate_directDebitAnnouncement } from "./default_email_templates/directdebitannouncement";
import { defaultTemplate_enrollmentCreated } from "./default_email_templates/enrollmentcreated";
import { defaultTemplate_evaluationFinalized } from "./default_email_templates/evaluationfinalized";
import { defaultTemplate_invitationCreated } from "./default_email_templates/invitationcreated";
import { defaultTemplate_mutualityCertificateCreated } from "./default_email_templates/mutualitycertificatecreated";
import { defaultTemplate_newEnrollmentRequest } from "./default_email_templates/newenrollmentrequest";
import { defaultTemplate_newFileNote } from "./default_email_templates/newfilenote";
import { defaultTemplate_newMessage } from "./default_email_templates/newmessage";
import { defaultTemplate_newMessageCC } from "./default_email_templates/newmessagecc";
import { defaultTemplate_newTextNote } from "./default_email_templates/newtextnote";
import { defaultTemplate_newWaitinglist } from "./default_email_templates/newwaitinglist";
import { defaultTemplate_otherInvoiceReminder } from "./default_email_templates/otherinvoicereminder";
import { defaultTemplate_passwordlessLogin } from "./default_email_templates/passwordlesslogin";
import { defaultTemplate_periodicPaymentReminder } from "./default_email_templates/periodicpaymentreminder";
import { defaultTemplate_resetPassword } from "./default_email_templates/resetPassword";
import {
  defaultTemplate_teacherAbsence_lessonMoved,
  defaultTemplate_teacherAbsence_lessonMoved_SMS,
  defaultTemplate_teacherAbsence_lessonRemoved,
  defaultTemplate_teacherAbsence_lessonRemoved_SMS,
  defaultTemplate_teacherAbsence_noAction,
  defaultTemplate_teacherAbsence_noAction_SMS,
  defaultTemplate_teacherAbsence_replacementTeacher,
  defaultTemplate_teacherAbsence_replacementTeacher_SMS,
} from "./default_email_templates/teacherabsence";
import { makeEmailWithNewTemplate } from "./newemailstyles";
import { parseStringToHyperscriptServerside } from "./parsestringtohyperscriptserverside";
import { invoiceSubject } from "../finance/types";
import { defaultTemplate_studentChargeCreated } from "./default_email_templates/studentchargecreated";
import { getEnrollmentrequestFull } from "../../pages/approve_enrollment_request/server";

export type queueableEmail =
  | {
      tag: "EnrollmentCreatedByAdmin";
      studentId: studentid;
      enrollmentId: enrollmentid;
    }
  | {
      tag: "EnrollmentRequestApproved";
      studentId: studentid;
      enrollmentId: enrollmentid;
    }
  | {
      tag: "InvoiceReminder";
      studentId: studentid;
      enrollmentId: enrollmentid;
      expectedPaymentId: expectedpaymentid;
    }
  | {
      tag: "OtherInvoiceReminder";
      studentId: studentid;
      expectedPaymentId: expectedpaymentid;
    }
  | {
      tag: "StudentChargeCreated";
      studentId: studentid;
      studentChargeId: student_charge_id;
    }
  | {
      tag: "PeriodicPaymentReminder";
      studentId: studentid;
      enrollmentId: enrollmentid | null;
      expectedpaymentId: expectedpaymentid;
    }
  | {
      tag: "DirectDebitAnnouncement";
      studentId: studentid;
      enrollmentId: enrollmentid | null;
      expectedpaymentId: expectedpaymentid;
    }
  | {
      tag: "EvaluationFinalized";
      studentId: studentid;
      enrollmentId: enrollmentid;
      evaluationId: evaluationid;
    }
  | {
      tag: "InvitationCreated";
      studentId: studentid;
      enrollmentId: enrollmentid;
      enrollmentrequestId: enrollmentrequestid;
      shouldShowOtherSlotLink: boolean;
    }
  | {
      tag: "MutualityCertificateCreated";
      studentId: studentid;
      enrollmentId: enrollmentid;
    }
  | {
      tag: "TeacherAbsence_Replacement";
      studentId: studentid;
      lessonId: lessonid;
      enrollmentId: enrollmentid;
    }
  | {
      tag: "TeacherAbsence_Move";
      studentId: studentid;
      lessonId: lessonid;
      enrollmentId: enrollmentid;
    }
  | {
      tag: "TeacherAbsence_Removed";
      studentId: studentid;
      lessonId: lessonid;
      enrollmentId: enrollmentid;
    }
  | {
      tag: "TeacherAbsence_Nothing";
      studentId: studentid;
      lessonId: lessonid;
      enrollmentId: enrollmentid;
    };

export type sendableSms =
  | {
      tag: "TeacherAbsence_Replacement_SMS";
      lessonId: lessonid;
      enrollmentId: enrollmentid;
    }
  | {
      tag: "TeacherAbsence_Move_SMS";
      lessonId: lessonid;
      enrollmentId: enrollmentid;
    }
  | {
      tag: "TeacherAbsence_Removed_SMS";
      lessonId: lessonid;
      enrollmentId: enrollmentid;
    }
  | {
      tag: "TeacherAbsence_Nothing_SMS";
      lessonId: lessonid;
      enrollmentId: enrollmentid;
    };

export type nonQueueableMessage =
  | noteOrMessage
  | {
      tag: "NewGroupCommunication";
      html: string;
      title: string;
      attachment: { name: string; mimetype: string; content: Buffer } | null;
      target:
        | {
            tag: "students";

            studentids: studentid[];
          }
        | { tag: "teachers"; teacherids: teacherid[] }
        | {
            tag: "enrollments";
            enrollments: {
              id: enrollmentid;
              studentid: studentid;
              variables: Record<string, string>;
            }[];
          };
    };

export type noteOrMessage =
  | { tag: "NewMessage"; messageId: messageid }
  | {
      tag: "NewTextNote";
      textNoteId: textnoteid;
    }
  | { tag: "NewFileNote"; fileNoteId: filenoteid };

export type ccMessage = { tag: "NewMessageCC"; messageId: messageid };

export type oneOffMessage =
  | {
      tag: "AbsenceRequestedByStudent";
      lessonId: lessonid;
      studentId: studentid;
      toAdmin: boolean;
    }
  | {
      tag: "NewEnrollmentRequest";
      studentId: studentid;
      enrollmentrequestId: enrollmentrequestid;
      showTeacherName: boolean;
    }
  | {
      tag: "NewWaitinglistPrivate";
      studentId: studentid;
      waitinglistId: waitinglistid;
    }
  | {
      tag: "NewWaitinglistLessongroup";
      studentId: studentid;
      waitinglistLessongroupId: waitinglistlessongroupid;
    }
  | {
      tag: "ConfirmEnrollmentRequest";
      firstname: string;
      lastname: string;
      email: string;
      confirmationlink: string;
      enrollmentrequestId: enrollmentrequestid;
    }
  | {
      tag: "ResetPassword";
      email: string;
      newpasswordlink: string;
      requestresetpasswordlink: string;
    }
  | {
      tag: "PasswordlessLogin";
      email: string;
      link: string;
    };

const dateFormatter = joda.DateTimeFormatter.ofPattern("dd/MM/yyyy");
const timeFormatter = joda.DateTimeFormatter.ofPattern("HH:mm");

export async function getCurrentEmailTemplate(
  db: connection,
  template_type: messagetemplatetype,
  messagetemplateid: messagetemplateid | null,
): Promise<{ title: string; html: string }> {
  const fromDb =
    messagetemplateid !== null
      ? await message_templates.getOne(db, { id: messagetemplateid })
      : await get_user_default_template_for_type(db, { typ: template_type });
  if (fromDb) {
    if (fromDb.template_type !== template_type) {
      throw new Error(
        `Fatal error getCurrentEmailTemplate: ${template_type} vs ${fromDb.template_type}`,
      );
    }
    return fromDb;
  } else {
    const def = getDefaultEmailTemplate(template_type);
    return { title: def.title, html: def.body };
  }
}

export function getDefaultEmailTemplate(template_type: messagetemplatetype): {
  title: string;
  body: string;
  placeholders: Record<string, string>;
  placeholder_help?: Record<string, string>;
} {
  switch (template_type) {
    case "EnrollmentCreatedPrivate":
      return defaultTemplate_enrollmentCreated;
    case "EnrollmentCreatedGroup":
      return defaultTemplate_enrollmentCreated;
    case "EnrollmentCreatedCamp":
      return defaultTemplate_enrollmentCreated;
    case "InvoiceReminder":
      return defaultTemplate_enrollmentCreated;
    case "OtherInvoiceReminder":
      return defaultTemplate_otherInvoiceReminder;
    case "PeriodicPaymentReminder":
      return defaultTemplate_periodicPaymentReminder;
    case "DirectDebitAnnouncement":
      return defaultTemplate_directDebitAnnouncement;
    case "EvaluationFinalized":
      return defaultTemplate_evaluationFinalized;
    case "StudentChargeCreated":
      return defaultTemplate_studentChargeCreated;
    case "TeacherAbsence_Replacement":
      return defaultTemplate_teacherAbsence_replacementTeacher;
    case "TeacherAbsence_Replacement_SMS":
      return defaultTemplate_teacherAbsence_replacementTeacher_SMS;
    case "TeacherAbsence_Move":
      return defaultTemplate_teacherAbsence_lessonMoved;
    case "TeacherAbsence_Move_SMS":
      return defaultTemplate_teacherAbsence_lessonMoved_SMS;
    case "TeacherAbsence_Removed":
      return defaultTemplate_teacherAbsence_lessonRemoved;
    case "TeacherAbsence_Removed_SMS":
      return defaultTemplate_teacherAbsence_lessonRemoved_SMS;
    case "TeacherAbsence_Nothing":
      return defaultTemplate_teacherAbsence_noAction;
    case "TeacherAbsence_Nothing_SMS":
      return defaultTemplate_teacherAbsence_noAction_SMS;
    case "InvitationCreated":
      return defaultTemplate_invitationCreated;
    case "NewMessage":
      return defaultTemplate_newMessage;
    case "NewTextNote":
      return defaultTemplate_newTextNote;
    case "NewFileNote":
      return defaultTemplate_newFileNote;
    case "MutualityCertificateCreated":
      return defaultTemplate_mutualityCertificateCreated;
    default:
      return checkAllCasesHandled(template_type);
  }
}

export async function createSmsServerside(
  db: connection,
  mess: sendableSms,
  messagetemplateid: messagetemplateid | null,
): Promise<string> {
  const schoolname = await getServerSetting(
    db,
    schoolname_schoolnamesetting_tab,
    "",
  );
  const schoolurl = await getServerSetting(db, schoolurl_tab, "");
  const currentTemplate = await getCurrentEmailTemplate(
    db,
    mess.tag,
    messagetemplateid,
  );

  const stus = await getstudentsforenrollments(db, {
    enrollmentids: [mess.enrollmentId],
  });
  if (stus.length !== 1) {
    throw new Error(`Student not found for enrollment id ${mess.enrollmentId}`);
  }
  const stu = stus[0];
  const l = await get_lesson_for_replacement_email(db, {
    lesson_id: mess.lessonId,
  });
  if (!l) {
    throw new Error(`Lesson with id ${mess.lessonId} not found`);
  }
  const shared = {
    schoolname: schoolname,
    schoolurl: schoolurl,
    student_firstname: stu.firstname,
    student_lastname: stu.lastname,
    instrument_name: l.instrument_description,
    lesson_date: l.date.format(dateFormatter),
    lesson_time: l.time.format(timeFormatter),
  } as const;
  if (mess.tag === "TeacherAbsence_Replacement_SMS") {
    const templ = defaultTemplate_teacherAbsence_replacementTeacher_SMS;
    return applyPlaceholders(templ, currentTemplate, {
      ...shared,
      teacher_firstname: l.planned_teacher_firstname,
      teacher_lastname: l.planned_teacher_lastname,
      replacement_teacher_firstname: l.actual_teacher_firstname,
      replacement_teacher_lastname: l.actual_teacher_lastname,
    }).body;
  } else if (mess.tag === "TeacherAbsence_Move_SMS") {
    const templ = defaultTemplate_teacherAbsence_lessonMoved_SMS;
    return applyPlaceholders(templ, currentTemplate, {
      ...shared,
      // This is possibly empty when the user removes the replacement lesson
      new_lesson_date: l.replacement_date
        ? l.replacement_date.format(dateFormatter)
        : "",
      new_lesson_time: l.replacement_time
        ? l.replacement_time.format(timeFormatter)
        : "",
      new_lesson_room: !isNil(l.replacement_location)
        ? renderLessonLocation(
            l.replacement_location,
            l.replacement_room_description,
          )
        : "",
      new_lesson_site: l.replacement_site_description || "",
      teacher_firstname: l.actual_teacher_firstname,
      teacher_lastname: l.actual_teacher_lastname,
    }).body;
  } else if (mess.tag === "TeacherAbsence_Removed_SMS") {
    const templ = defaultTemplate_teacherAbsence_lessonRemoved_SMS;
    return applyPlaceholders(templ, currentTemplate, {
      ...shared,
      teacher_firstname: l.actual_teacher_firstname,
      teacher_lastname: l.actual_teacher_lastname,
    }).body;
  } else if (mess.tag === "TeacherAbsence_Nothing_SMS") {
    const templ = defaultTemplate_teacherAbsence_noAction_SMS;
    return applyPlaceholders(templ, currentTemplate, {
      ...shared,
      teacher_firstname: l.actual_teacher_firstname,
      teacher_lastname: l.actual_teacher_lastname,
    }).body;
  } else {
    return checkAllCasesHandled(mess);
  }
}

export async function createEmailServerside(
  db: connection,
  { schoolname, schoolurl }: Pick<classyTsContext, "schoolname" | "schoolurl">,
  mess: queueableEmail | nonQueueableMessage | ccMessage | oneOffMessage,
  messagetemplateid: messagetemplateid | null,
): Promise<{ title: string; body: HTMLElement }> {
  return impl().then(({ title, body }) => ({
    title,
    body: makeEmailWithNewTemplate(
      { schoolname, schoolurl },
      stringToJsx(body),
    ),
  }));
  async function impl(): Promise<{ title: string; body: string }> {
    if (mess.tag === "NewGroupCommunication") {
      return {
        title: mess.title,
        body: mess.html,
      };
    }
    if (mess.tag === "AbsenceRequestedByStudent") {
      const templ = defaultTemplate_absenceRequested;
      const m = await notNullF(get_lesson_for_absencerequest_email)(db, {
        lesson_id: mess.lessonId,
        student_id: mess.studentId,
      });
      const teachersCanPlan = await getServerSetting(
        db,
        teacherscanplan_tab,
        false,
      );

      return applyPlaceholders(
        templ,
        { title: templ.title, html: templ.body },
        {
          ...m,
          schoolname,
          schoolurl,
          instrument_name: m.instrument_description,
          lesson_time: m.lesson_time.format(timeFormatter),
          lesson_date: m.lesson_date.format(dateFormatter),
          lesson_weekday: translateWeekday(m.lesson_date.dayOfWeek()),
          receiver_is_admin: mess.toAdmin ? "admin" : "",
          requested_absences_link:
            mess.toAdmin || teachersCanPlan
              ? schoolurl + "/absencestoapprove"
              : "",
        },
      );
    } else if (mess.tag === "NewEnrollmentRequest") {
      const templ = defaultTemplate_newEnrollmentRequest;
      const m = await notNullF(get_enrollmentrequest_for_newenrreq)(db, {
        enrollmentrequest_id: mess.enrollmentrequestId,
      });

      return applyPlaceholders(
        templ,
        { title: templ.title, html: templ.body },
        {
          ...m,
          schoolname,
          schoolurl,
          instrument_name: m.instrument_name,
          teacher_name:
            m.teacher_firstname === null || m.teacher_lastname === null
              ? ""
              : mess.showTeacherName === false
              ? ""
              : "bij " + m.teacher_firstname + " " + m.teacher_lastname,
          enrollment_request_link:
            schoolurl +
            enrollment_requestRoute.link({
              enrollmentrequestid: mess.enrollmentrequestId,
            }),
        },
      );
    } else if (mess.tag === "NewWaitinglistPrivate") {
      const templ = defaultTemplate_newWaitinglist;
      const m = await notNullF(get_waitinglist_private_by_id)(db, {
        waitinglist_id: mess.waitinglistId,
      });

      const formulas = (m.formulas || [])
        .map((f) => `<li>${f.description}</li>`)
        .join("");

      const ranges = (m.ranges || [])
        .map(
          (r) =>
            `<li>${renderTimeRangePlusWeekday(
              r.starttime,
              r.endtime,
              parseWeekday(r.weekday),
            )}</li>`,
        )
        .join("");

      return applyPlaceholders(
        templ,
        { title: templ.title, html: templ.body },
        {
          schoolname,
          schoolurl,
          subject_description:
            "<li>Privéles</li>" +
            `<li>${m.instrument.description}</li>` +
            (m.teacher.firstname === null || m.teacher.lastname === null
              ? ""
              : "<li>Bij " +
                m.teacher.firstname +
                " " +
                m.teacher.lastname +
                "</li>"),
          student_firstname: m.student.firstname,
          student_lastname: m.student.lastname,
          formulas:
            formulas.length > 0 ? `<div>Formules:</div> ${formulas}` : "",
          ranges: ranges.length > 0 ? `<div>Tijdstippen:</div> ${ranges}` : "",
        },
      );
    } else if (mess.tag === "NewWaitinglistLessongroup") {
      const templ = defaultTemplate_newWaitinglist;
      const m = await notNullF(get_waitinglist_group_by_id)(db, {
        waitinglistlessongroup_id: mess.waitinglistLessongroupId,
      });

      const type = parseFormulaType(m.type_);

      return applyPlaceholders(
        templ,
        { title: templ.title, html: templ.body },
        {
          schoolname,
          schoolurl,
          subject_description:
            `<li>${renderFormulaTypeShort(type)}</li>` +
            `<li>${m.instrument.description}</li>` +
            `<li>Bij ${renderFirstNameLastName(m.teacher)}</li>` +
            `<li>${m.time.format(HHmm)}</li>` +
            `<li>${translateWeekday(parseWeekday(m.weekday))}</li>` +
            (m.firstlesson
              ? `<li>Eerste les op ${ddMMMMyyyy(m.firstlesson)}</li>`
              : ""),
          student_firstname: m.student.firstname,
          student_lastname: m.student.lastname,
          formulas: "",
          ranges: "",
        },
      );
    } else if (mess.tag === "ConfirmEnrollmentRequest") {
      const templ = defaultTemplate_confirmEnrollmentRequest;
      const er = await notNullF(get_enrollmentrequest_for_newenrreq)(db, {
        enrollmentrequest_id: mess.enrollmentrequestId,
      });
      const loc = er.location === null ? null : er.location;
      const type = er.formula_type ? parseFormulaType(er.formula_type) : null;

      return applyPlaceholders(
        templ,
        { title: templ.title, html: templ.body },
        {
          schoolname,
          schoolurl,
          student_firstname: mess.firstname,
          student_lastname: mess.lastname,
          confirmation_link: mess.confirmationlink,
          teacher_firstname:
            type?.tag === "Camp" ? "" : er.teacher_firstname || "",
          teacher_lastname:
            type?.tag === "Camp" ? "" : er.teacher_lastname || "",
          lesson_weekday: er.lesson_weekday
            ? translateWeekday(parseWeekday(er.lesson_weekday))
            : "",
          lesson_time: er.lesson_time?.format(HHmm) || "",
          instrument_name: er.instrument_name,
          formula_description: er.formula_description || "",
          formula_comments: er.formula_comments || "",
          dates:
            er.first_lesson_date && er.last_lesson_date
              ? ddMMMMyyyy(er.first_lesson_date) +
                " - " +
                ddMMMMyyyy(er.last_lesson_date)
              : "",
          lesson_online: loc === "OnlineS" ? "Online" : "",
          lesson_at_home: loc === "HomeS" ? "Home" : "",
          lesson_room: er.lesson_room || "",
        },
      );
    } else if (mess.tag === "ResetPassword") {
      const templ = defaultTemplate_resetPassword;

      return applyPlaceholders(
        templ,
        { title: templ.title, html: templ.body },
        {
          schoolname,
          schoolurl,
          new_password_link: mess.newpasswordlink,
          request_reset_password_link: mess.requestresetpasswordlink,
        },
      );
    } else if (mess.tag === "PasswordlessLogin") {
      const templ = defaultTemplate_passwordlessLogin;

      return applyPlaceholders(
        templ,
        { title: templ.title, html: templ.body },
        {
          schoolname,
          schoolurl,
          link: mess.link,
        },
      );
    } else if (mess.tag === "NewMessageCC") {
      const templ = defaultTemplate_newMessageCC;
      const m = await notNullF(get_message_for_email)(db, {
        message_id: mess.messageId,
        schoolname,
      });
      return applyPlaceholders(
        templ,
        { title: templ.title, html: templ.body },
        {
          schoolname: schoolname,
          schoolurl: schoolurl,
          authorname: m.authorname,
          message_text: m.message_text,
          receivername: m.receivername,
          first_20_characters: m.message_text.substring(0, 20),
        },
      );
    }

    const templateName: messagetemplatetype =
      await queuedMessageToMessageTemplateTypeAsync(db, mess);

    const currentTemplate = await getCurrentEmailTemplate(
      db,
      templateName,
      messagetemplateid,
    );
    if (
      mess.tag === "TeacherAbsence_Replacement" ||
      mess.tag === "TeacherAbsence_Move" ||
      mess.tag === "TeacherAbsence_Removed" ||
      mess.tag === "TeacherAbsence_Nothing"
    ) {
      const stus = await getstudentsforenrollments(db, {
        enrollmentids: [mess.enrollmentId],
      });
      if (stus.length !== 1) {
        throw new Error(
          `Student not found for enrollment id ${mess.enrollmentId}`,
        );
      }
      const stu = stus[0];
      const l = await get_lesson_for_replacement_email(db, {
        lesson_id: mess.lessonId,
      });
      if (!l) {
        throw new Error(`Lesson with id ${mess.lessonId} not found`);
      }
      const shared = {
        schoolname: schoolname,
        schoolurl: schoolurl,
        student_firstname: stu.firstname,
        student_lastname: stu.lastname,
        instrument_name: l.instrument_description,
        lesson_date: l.date.format(dateFormatter),
        lesson_time: l.time.format(timeFormatter),
      } as const;
      if (mess.tag === "TeacherAbsence_Replacement") {
        const templ = defaultTemplate_teacherAbsence_replacementTeacher;
        return applyPlaceholders(templ, currentTemplate, {
          ...shared,
          teacher_firstname: l.planned_teacher_firstname,
          teacher_lastname: l.planned_teacher_lastname,
          replacement_teacher_firstname: l.actual_teacher_firstname,
          replacement_teacher_lastname: l.actual_teacher_lastname,
        });
      } else if (mess.tag === "TeacherAbsence_Move") {
        const templ = defaultTemplate_teacherAbsence_lessonMoved;
        return applyPlaceholders(templ, currentTemplate, {
          ...shared,
          // This is possibly empty when the user removes the replacement lesson
          teacher_firstname: l.actual_teacher_firstname,
          teacher_lastname: l.actual_teacher_lastname,
          new_lesson_date: l.replacement_date
            ? l.replacement_date.format(dateFormatter)
            : "",
          new_lesson_time: l.replacement_time
            ? l.replacement_time.format(timeFormatter)
            : "",
          new_lesson_room: !isNil(l.replacement_location)
            ? renderLessonLocation(
                l.replacement_location,
                l.replacement_room_description,
              )
            : "",
          new_lesson_site: l.replacement_site_description || "",
        });
      } else if (mess.tag === "TeacherAbsence_Removed") {
        const templ = defaultTemplate_teacherAbsence_lessonRemoved;
        return applyPlaceholders(templ, currentTemplate, {
          ...shared,
          teacher_firstname: l.actual_teacher_firstname,
          teacher_lastname: l.actual_teacher_lastname,
        });
      } else if (mess.tag === "TeacherAbsence_Nothing") {
        const templ = defaultTemplate_teacherAbsence_noAction;
        return applyPlaceholders(templ, currentTemplate, {
          ...shared,
          teacher_firstname: l.actual_teacher_firstname,
          teacher_lastname: l.actual_teacher_lastname,
        });
      } else {
        return checkAllCasesHandled(mess);
      }
    } else if (
      mess.tag === "EnrollmentCreatedByAdmin" ||
      mess.tag === "InvoiceReminder" ||
      mess.tag === "EnrollmentRequestApproved"
    ) {
      return await enrollmentCreatedEmail(
        db,
        { schoolname, schoolurl },
        mess,
        currentTemplate,
      );
    } else if (mess.tag === "OtherInvoiceReminder") {
      return await otherInvoiceReminderEmail(
        db,
        { schoolname, schoolurl },
        mess,
        currentTemplate,
      );
    } else if (mess.tag === "DirectDebitAnnouncement") {
      const templ = defaultTemplate_directDebitAnnouncement;
      const res = await get_expected_payment_for_reminder(db, {
        expectedpayment_id: mess.expectedpaymentId,
      });
      if (!res) {
        throw new Error(
          `Failed to find expectedpayment for id ${mess.expectedpaymentId}`,
        );
      }
      const subject = await getInvoiceSubjects(db, {
        tag: "invoice",
        invoices: [{ enrollmentrequestid: null, ...res }],
      }).then((invs) => invs[0]);

      return applyPlaceholders(templ, currentTemplate, {
        schoolname,
        schoolurl,
        student_firstname: res.student_firstname,
        student_lastname: res.student_lastname,
        invoice_subject: invoiceSubjectForTemplate(subject),
        expected_payment_amount: renderCurrency(res.expected_payment_amount),
        expected_payment_date: res.expected_payment_date.format(ddMMyyyy),
        invoice_number: res.invoice_number,
        teacher_firstname:
          subject.tag === "enrollment" ? subject.teacher.firstname || "" : "",
        teacher_lastname:
          subject.tag === "enrollment" ? subject.teacher.lastname || "" : "",
        lesson_weekday:
          subject.tag === "enrollment"
            ? translateWeekday(parseWeekday(subject.lg.weekday)) || ""
            : "",
        lesson_time:
          subject.tag === "enrollment"
            ? subject.lg.time.format(HHmm) || ""
            : "",
      });
    } else if (mess.tag === "PeriodicPaymentReminder") {
      const templ = defaultTemplate_periodicPaymentReminder;
      const res = await get_expected_payment_for_reminder(db, {
        expectedpayment_id: mess.expectedpaymentId,
      });
      if (!res) {
        throw new Error(
          `Failed to find expectedpayment for id ${mess.expectedpaymentId}`,
        );
      }

      const subject = await getInvoiceSubjects(db, {
        tag: "invoice",
        invoices: [{ enrollmentrequestid: null, ...res }],
      }).then((invs) => invs[0]);

      const always_show_wire_instructions = await getAlwaysShowWireInstructions(
        db,
      );
      const schoolAccountNumber = await getServerSetting(
        db,
        schoolaccount_tab,
        "",
      );
      const electronicPaymentsEnabled = await getElectronicPaymentsEnabled(db);
      const payenrollmentUrl =
        schoolurl +
        routes.payExpectedPaymentsRoute.link({
          expectedpayments: { expectedpaymentids: [mess.expectedpaymentId] },
        });

      return applyPlaceholders(templ, currentTemplate, {
        schoolname,
        schoolurl,
        student_firstname: res.student_firstname,
        student_lastname: res.student_lastname,
        invoice_subject: invoiceSubjectForTemplate(subject),
        expected_payment_amount: renderCurrency(res.expected_payment_amount),
        expected_payment_date: res.expected_payment_date.format(ddMMyyyy),
        electronic_payment_link: electronicPaymentsEnabled
          ? payenrollmentUrl
          : "",
        wire_payment: !electronicPaymentsEnabled ? "wire" : "",
        always_show_wire_instructions: always_show_wire_instructions
          ? "true"
          : "",
        school_account_number: schoolAccountNumber || "",
        invoice_number: res.invoice_number,
        teacher_firstname:
          subject.tag === "enrollment" ? subject.teacher.firstname || "" : "",
        teacher_lastname:
          subject.tag === "enrollment" ? subject.teacher.lastname || "" : "",
        lesson_weekday:
          subject.tag === "enrollment"
            ? translateWeekday(parseWeekday(subject.lg.weekday)) || ""
            : "",
        lesson_time:
          subject.tag === "enrollment"
            ? subject.lg.time.format(HHmm) || ""
            : "",
      });
    } else if (mess.tag === "EvaluationFinalized") {
      const templ = defaultTemplate_evaluationFinalized;
      const res = await get_evaluation_for_email(db, {
        evaluation_id: mess.evaluationId,
      });
      if (!res) {
        throw new Error(
          `Failed to find evaluation for enrollmentid ${mess.enrollmentId}`,
        );
      }
      return applyPlaceholders(templ, currentTemplate, res);
    } else if (mess.tag === "InvitationCreated") {
      const templ = defaultTemplate_invitationCreated;
      const enr = await get_enrollment_for_invitation(db, {
        enrollment_id: mess.enrollmentId,
      });
      const er = await getEnrollmentrequestFull(db, {
        enrollmentrequestid: mess.enrollmentrequestId,
      });
      if (!enr) {
        throw new Error(`Failed to find enrollment ${mess.enrollmentId}`);
      }
      if (!er) {
        throw new Error(
          `Failed to find enrollmentrequest ${mess.enrollmentrequestId}`,
        );
      }
      return applyPlaceholders(templ, currentTemplate, {
        schoolname: schoolname,
        schoolurl: schoolurl,
        student_firstname: enr.student_firstname,
        student_lastname: enr.student_lastname,
        instrument_name: enr.instrument_name,
        teacher_firstname: enr.teacher_firstname,
        teacher_lastname: enr.teacher_lastname,
        lesson_weekday: translateWeekday(
          parseWeekday(enr.weekday_english),
        ).toLowerCase(),
        lesson_time: enr.time_stamp.format(timeFormatter),
        last_lesson_date: enr.last_lesson_date?.format(dateFormatter) || "",
        reserved_until_date: er.reserveduntil?.format(dateFormatter) || "",
        reenrollment_link: schoolurl + "/invitation/" + er.id,
        should_show_other_slot_link: mess.shouldShowOtherSlotLink
          ? "show_other_slot_link"
          : "",
        public_enrollments_link: schoolurl + "/planning_start_public",
        new_enrollment_first_lesson_date:
          er.contents.firstlesson?.format(dateFormatter) || "",
        new_enrollment_last_lesson_date:
          er.contents.lastlesson?.format(dateFormatter) || "",
      });
    } else if (mess.tag === "NewMessage") {
      const templ = defaultTemplate_newMessage;
      const m = await get_message_for_email(db, {
        message_id: mess.messageId,
        schoolname,
      });
      if (!m) {
        throw new Error(`Failed to find message: ${mess.messageId}`);
      }
      return applyPlaceholders(templ, currentTemplate, {
        authorname: m.authorname,
        schoolname: schoolname,
        message_text: m.message_text,
        schoolurl: schoolurl,
        first_20_characters: m.message_text.substring(0, 20),
      });
    } else if (mess.tag === "StudentChargeCreated") {
      const templ = defaultTemplate_studentChargeCreated;
      const sc = await get_student_charge_email(db, {
        student_charge_id_: mess.studentChargeId,
      });
      if (!sc) {
        throw new Error(`Student charge not found: ${mess.studentChargeId}`);
      }

      const invPlaceholders = await calcInvoicePlaceholders(
        db,
        { schoolname, schoolurl },
        sc,
        null,
        null,
      );

      return applyPlaceholders(templ, currentTemplate, {
        schoolname: schoolname,
        schoolurl: schoolurl,
        student_firstname: sc.student_firstname,
        student_lastname: sc.student_lastname,
        student_charge_description: sc.student_charge_description,
        student_birthday: sc.student_birthday
          ? sc.student_birthday.format(ddMMyyyy)
          : "",
        student_adress_street: sc.student_street,
        student_adress_number: sc.student_number,
        student_adress_bus: sc.student_bus,
        student_adress_zip: sc.student_zip,
        student_adress_city: sc.student_city,
        ...invPlaceholders,
      });
    } else if (mess.tag === "MutualityCertificateCreated") {
      const templ = defaultTemplate_mutualityCertificateCreated;
      const enr = await get_enrollment_created_email(db, {
        enrollment_id: mess.enrollmentId,
      });
      if (!enr) {
        throw new Error(`Enrollment not found: ${mess.enrollmentId}`);
      }
      return applyPlaceholders(templ, currentTemplate, {
        schoolname: schoolname,
        schoolurl: schoolurl,
        student_firstname: enr.student_firstname,
        student_lastname: enr.student_lastname,
        firstday: enr.first_lesson_date.format(ddMMyyyy),
        lastday: enr.lesson_last_lesson?.format(ddMMyyyy) || "",
      });
    } else if (mess.tag === "NewTextNote") {
      const templ = defaultTemplate_newTextNote;
      const note = await get_text_note_for_email(db, {
        textnote_id: mess.textNoteId,
        schoolname,
      });
      if (!note) {
        throw new Error(`Failed to find text note ${mess.textNoteId}`);
      }
      const res = applyPlaceholders(templ, currentTemplate, {
        schoolname,
        schoolurl,
        authorname: note.authorname,
        lesson_date: note.lesson_date.format(dateFormatter),
        note_text: makeHtmlFromTextNote({
          content: note.note_text,
        }),
        author_is_teacher: !isNil(note.authorteacherid) ? "true" : "",
        author_is_student: !isNil(note.authorstudentid) ? "true" : "",
        teacher_firstname: note.teacher_firstname,
        teacher_lastname: note.teacher_firstname,
        instrument_name: note.instrument_name,
        lesson_time: note.lesson_time.format(HHmm),
        lesson_weekday: translateWeekday(parseWeekday(note.lesson_weekday)),
      });
      return res;
    } else if (mess.tag === "NewFileNote") {
      const templ = defaultTemplate_newFileNote;
      const note = await get_file_note_for_email(db, {
        filenote_id: mess.fileNoteId,
        schoolname,
      });
      if (!note) {
        throw new Error(`Failed to find file note ${mess.fileNoteId}`);
      }
      return applyPlaceholders(templ, currentTemplate, {
        schoolname,
        schoolurl,
        authorname: note.authorname,
        lesson_date: note.lesson_date.format(dateFormatter),
        file_name: `<a href="${
          schoolurl +
          routes.downloadFileNoteSpec.route.link({
            filenoteid: note.id,
            storagefileid: note.storagefileid,
          })
        }" target="_blank">${note.file_name}</a>`,
      });
    } else {
      return checkAllCasesHandled(mess);
    }
  }
}

function invoiceSubjectForTemplate(subject: invoiceSubject) {
  const subj_rendered = renderInvoiceSubjectForStudentEmail(subject, {
    listStyle: "margin: 0px; padding: 0px; list-style: none;",
  });
  return `
    <div><b>${subj_rendered.title}</b></div>
    ${subj_rendered.list.outerHTML}
`;
}

async function otherInvoiceReminderEmail(
  db: connection,
  ctx: { schoolname: string; schoolurl: string },
  mess: {
    tag: "OtherInvoiceReminder";
    expectedPaymentId: expectedpaymentid;
  },
  currentTemplate: { title: string; html: string },
) {
  const templ = defaultTemplate_otherInvoiceReminder;

  const ep = await expected_payments.getOne(db, { id: mess.expectedPaymentId });
  if (!ep) {
    throw new Error("No expected payment found");
  }

  const invoice = await get_invoice_full(db, {
    invoice_id: ep.invoiceid,
  });
  if (!invoice) {
    throw new Error("No invoice found for periodfee");
  }

  const subject = await getInvoiceSubjects(db, {
    tag: "invoice",
    invoices: [{ ...invoice, invoiceid: invoice.id }],
  }).then((invs) => invs[0]);
  if (!subject) {
    throw new Error("No subject found");
  }

  const electronicPaymentsEnabled = await getElectronicPaymentsEnabled(db);
  const accountingSoftwareEnabled = !!(await getServerSetting(
    db,
    accountingsoftwarelink_software_tab,
    "",
  ));
  const invoiceDetails = renderSchoolInvoiceDetailsForEmail(
    { schoolname: ctx.schoolname },
    await promiseAllFromObject({
      vat: getServerSetting(db, invoicedetails_vat_tab, ""),
      address: getServerSetting(db, invoicedetails_address_tab, ""),
      extra: getServerSetting(db, invoicedetails_extra_tab, ""),
    }),
  );
  const schoolAccountNumber = await getServerSetting(db, schoolaccount_tab, "");

  const always_show_wire_instructions = await getAlwaysShowWireInstructions(db);

  const needsPayment = invoice.amount_left.intValue > 0;

  const paymentlink =
    ctx.schoolurl +
    routes.payExpectedPaymentsRoute.link({
      expectedpayments: {
        expectedpaymentids: (invoice.expectedpayments || []).map((ep) => ep.id),
      },
    });

  return applyPlaceholders(templ, currentTemplate, {
    schoolname: ctx.schoolname,
    schoolurl: ctx.schoolurl,
    always_show_wire_instructions: always_show_wire_instructions ? "true" : "",
    invoice_amount_total:
      invoice.amount_total.intValue === currency(0).intValue
        ? ""
        : renderCurrency(invoice.amount_total),
    invoice_amount_paid:
      invoice.amount_paid.intValue > 0
        ? renderCurrency(invoice.amount_paid)
        : "",
    electronic_payment_link:
      electronicPaymentsEnabled && needsPayment ? paymentlink : "",
    wire_payment:
      electronicPaymentsEnabled || accountingSoftwareEnabled
        ? ""
        : needsPayment
        ? "wire"
        : "",
    school_account_number: schoolAccountNumber || "",
    invoice_number: invoice.externalidstring,
    invoice_details: invoiceDetails,
    student_firstname: subject.student.firstname,
    student_lastname: subject.student.lastname,
    invoice_subject: invoiceSubjectForTemplate(subject),
  });
}

async function enrollmentCreatedEmail(
  db: connection,
  ctx: { schoolname: string; schoolurl: string },
  mess:
    | { tag: "EnrollmentCreatedByAdmin"; enrollmentId: enrollmentid }
    | { tag: "InvoiceReminder"; enrollmentId: enrollmentid }
    | { tag: "EnrollmentRequestApproved"; enrollmentId: enrollmentid },
  currentTemplate: { title: string; html: string },
) {
  const templ = defaultTemplate_enrollmentCreated;
  const enr = await get_enrollment_created_email(db, {
    enrollment_id: mess.enrollmentId,
  });
  if (enr === null) {
    throw new Error("Failed to query email data for enrollment");
  }
  const invPlaceholders = await calcInvoicePlaceholders(
    db,
    ctx,
    enr,
    mess.enrollmentId,
    {
      studentid: enr.student_id,
      periodid: enr.starts_in_period,
    },
  );

  return applyPlaceholders(templ, currentTemplate, {
    schoolname: ctx.schoolname,
    schoolurl: ctx.schoolurl,
    created_by_admin_or_teacher:
      mess.tag === "EnrollmentCreatedByAdmin" ? "true" : "",
    enrollmentrequest_approved:
      mess.tag === "EnrollmentRequestApproved" ? "true" : "",
    lesson_is_camp_lesson:
      enr.lesson_type.startsWith("Camp") === true ? "true" : "",
    lesson_is_group_lesson:
      enr.lesson_type.startsWith("Group") === true ? "true" : "",
    lesson_is_private_lesson:
      enr.lesson_type.startsWith("Private") === true ? "true" : "",
    lesson_weekday: translateWeekday(
      parseWeekday(enr.lesson_weekday_english),
    ).toLowerCase(),
    lesson_time: enr.lesson_time_stamp.format(timeFormatter),
    lesson_no_location: enr.lesson_location === "NotSpecifiedS" ? "Empty" : "",
    lesson_online: enr.lesson_location === "OnlineS" ? "Online" : "",
    lesson_at_home: enr.lesson_location === "HomeS" ? "Home" : "",
    student_firstname: enr.student_firstname,
    student_lastname: enr.student_lastname,
    student_birthday: enr.student_birthday
      ? enr.student_birthday.format(ddMMyyyy)
      : "",
    student_adress_street: enr.student_street,
    student_adress_number: enr.student_number,
    student_adress_bus: enr.student_bus,
    student_adress_zip: enr.student_zip,
    student_adress_city: enr.student_city,
    teacher_firstname: enr.teacher_firstname,
    teacher_lastname: enr.teacher_lastname,
    lesson_room: enr.lesson_room,
    lesson_period: describePeriod(
      enr.lesson_period_firstday,
      enr.lesson_period_lastday,
    ),
    instrument_name: enr.instrument_name,
    formula_description: enr.formula_description,
    formula_comments: enr.formula_comments,
    number_of_lessons: enr.number_of_lessons.toString(),
    first_lesson_date: enr.first_lesson_date.format(dateFormatter),
    ...invPlaceholders,
  });
}

async function calcInvoicePlaceholders(
  db: connection,
  ctx: { schoolname: string; schoolurl: string },
  enr: {
    student_id: studentid;
    student_iban: iban | null;
    student_name_on_iban: string;
    student_direct_debit_allowed: boolean;
    third_party_seller_name: string | null;
    invoice_id: invoiceid | null;
    invoice_external_id: number | null;
    invoicelines:
      | {
          amount: price_adapted_to_lg_and_student;
          description: string;
          vat: number;
          ordering: number;
        }[]
      | null;
    expectedpayments:
      | {
          id: expectedpaymentid;
          amount: currency;
          date: joda.LocalDate;
          periodic_payment_method: periodic_payment_method | null;
          amount_paid: currency;
          amount_left: currency;
        }[]
      | null;
    amount_total: currency | null;
    amount_paid: currency | null;
    amount_left: currency | null;
    periodic_payment_method: periodic_payment_method | null;
  },
  enrollmentid: enrollmentid | null,
  period_fee: null | {
    studentid: studentid;
    periodid: periodid;
  },
) {
  const electronicPaymentsEnabled = await getElectronicPaymentsEnabled(db);
  const accountingSoftwareEnabled = !!(await getServerSetting(
    db,
    accountingsoftwarelink_software_tab,
    "",
  ));
  const invoiceDetails = renderSchoolInvoiceDetailsForEmail(
    { schoolname: ctx.schoolname },
    await promiseAllFromObject({
      vat: getServerSetting(db, invoicedetails_vat_tab, ""),
      address: getServerSetting(db, invoicedetails_address_tab, ""),
      extra: getServerSetting(db, invoicedetails_extra_tab, ""),
    }),
  );
  const schoolAccountNumber = await getServerSetting(db, schoolaccount_tab, "");

  const always_show_wire_instructions = await getAlwaysShowWireInstructions(db);

  const invoice =
    enr.invoice_external_id === null
      ? null
      : {
          external_id: enr.invoice_external_id,
          expectedpayments: enr.expectedpayments!,
          invoicelines: enr.invoicelines!,
          amount_total: enr.amount_total!,
          amount_paid: enr.amount_paid!,
          amount_left: enr.amount_left!,
        };
  const singlePaymentSchema = enr.periodic_payment_method === null;
  const periodicManualPaymentSchema = enr.periodic_payment_method === "manual";
  const periodicDirectDebitPaymentSchema =
    enr.periodic_payment_method === "direct_debit";
  const invoice_total_vat_percentage =
    invoice === null
      ? ""
      : (enr.invoicelines || []).reduce(
          (acc, il) =>
            // Vat percentage of this line, weighed by the part of the total amount
            acc.add(
              il.amount
                .divide(invoice?.amount_total || currency(0))
                .multiply(il.vat),
            ),
          currency(0),
        );

  const expectedPaymentsStillToPay = (enr.expectedpayments || []).filter(
    (ep) => ep.amount_left.intValue > 0,
  );

  const hasVat = (invoice?.invoicelines || []).some((il) => il.vat > 0);

  const pfInvoice =
    period_fee === null
      ? null
      : await get_invoice_for_periodfee(db, {
          student_id: period_fee.studentid,
          period_id: period_fee.periodid,
        });
  const needsPayment =
    (invoice && invoice.amount_left.intValue > 0) ||
    (pfInvoice && pfInvoice.amount_left.intValue > 0);

  const payment_link =
    ctx.schoolurl +
    (!isNil(enrollmentid)
      ? routes.payEnrollmentRoute.link({ enrollmentid: enrollmentid })
      : routes.payExpectedPaymentsRoute.link({
          expectedpayments: {
            expectedpaymentids: (enr.expectedpayments || []).map((ep) => ep.id),
          },
        }));

  return {
    invoice_total_amount: invoice ? renderCurrency(invoice.amount_total) : "",
    invoice_total_vat_percentage: invoice_total_vat_percentage.toString(),
    invoice_single_line_amount:
      invoice && invoice.invoicelines.length === 1
        ? renderCurrency(invoice.invoicelines[0].amount)
        : "",
    invoice_single_line_vat_percentage:
      invoice &&
      invoice.invoicelines.length === 1 &&
      invoice.invoicelines[0].vat > 0
        ? roundTo2(invoice.invoicelines[0].vat).toString()
        : "",
    invoice_multiple_lines_table:
      invoice && invoice.invoicelines.length > 1
        ? `
<table style="width: 100%; margin-bottom: 32px">
<tbody>
${invoice.invoicelines
  .map(
    (il) => `<tr>
        <td>${il.description}</td>
        <td>${renderCurrency(il.amount)}</td>
        ${hasVat ? "<td>" + roundTo2(il.vat).toString() + "% BTW</td>" : ""}
        </tr>`,
  )
  .join("\n")}
<tr>
  <td>${"Totaal"}</td>
  <td>${renderCurrency(
    invoice.invoicelines.reduce((acc, il) => acc.add(il.amount), currency(0)),
  )}</td>
  ${hasVat ? "<td></td>" : ""}
</tr>
</tbody>
</table>
`
        : "",
    invoice_paid:
      !invoice || invoice.amount_total.intValue === 0
        ? ""
        : invoice.amount_left.intValue === 0
        ? "paid"
        : "",
    invoice_amount_paid:
      invoice && invoice.amount_paid.intValue > 0
        ? renderCurrency(invoice.amount_paid)
        : "",
    invoice_partially_paid:
      !invoice || invoice.amount_total.intValue === 0
        ? ""
        : invoice.amount_paid.intValue > 0 && invoice.amount_left.intValue > 0
        ? renderCurrency(invoice.amount_left)
        : "",
    periodfee_amount:
      pfInvoice && pfInvoice.amount_total.intValue > 0
        ? renderCurrency(pfInvoice.amount_total)
        : "",
    periodfee_is_paid:
      pfInvoice && pfInvoice.amount_left.intValue <= 0 ? "paid" : "",
    periodfee_partially_paid:
      pfInvoice &&
      pfInvoice.amount_left.intValue > 0 &&
      pfInvoice.amount_left.intValue !== pfInvoice.amount_total.intValue
        ? renderCurrency(pfInvoice.amount_left)
        : "",
    payment_via_accounting_software:
      accountingSoftwareEnabled && needsPayment ? "accounting" : "",
    electronic_payment_link:
      electronicPaymentsEnabled &&
      needsPayment &&
      (singlePaymentSchema || periodicManualPaymentSchema)
        ? payment_link
        : "",
    always_show_wire_instructions: always_show_wire_instructions ? "true" : "",
    wire_payment:
      electronicPaymentsEnabled || accountingSoftwareEnabled
        ? ""
        : needsPayment && singlePaymentSchema
        ? "wire"
        : "",
    periodic_manual_payment:
      needsPayment && periodicManualPaymentSchema ? "true" : "",
    periodic_direct_debit_payment:
      needsPayment && periodicDirectDebitPaymentSchema ? "true" : "",
    direct_debit_info_or_approval_missing:
      needsPayment &&
      periodicDirectDebitPaymentSchema &&
      getInvoiceDirectDebitInfoStatus(invoice, {
        id: enr.student_id,
        iban: enr.student_iban,
        name_on_iban: enr.student_name_on_iban,
        direct_debit_allowed: enr.student_direct_debit_allowed,
      }) === "needs_info"
        ? "true"
        : "",
    direct_debit_info_link: routes.student_direct_debit_mandatesRoute.link(),
    no_third_party_seller:
      (enr.third_party_seller_name || "").trim().length > 0 ? "" : "true",
    third_party_seller_name: enr.third_party_seller_name || "",
    school_account_number: schoolAccountNumber || "",
    invoice_number: invoice ? invoice.external_id.toString() : "",
    invoice_details: (invoiceDetails || "").trim(),
    single_expected_payment_amount:
      expectedPaymentsStillToPay.length === 1
        ? renderCurrency(expectedPaymentsStillToPay[0].amount_left)
        : "",
    single_expected_payment_due_date:
      expectedPaymentsStillToPay.length === 1
        ? ddMMMMyyyy(expectedPaymentsStillToPay[0].date)
        : "",
    multiple_expected_payments_table:
      expectedPaymentsStillToPay.length > 1
        ? `
<table style="width: 100%; margin-bottom: 32px">
<tbody>
${expectedPaymentsStillToPay
  .map(
    (ep) => `<tr>
        <td>${renderCurrency(ep.amount_left)}</td>
        <td>${ddMMMMyyyy(ep.date)}</td>
        </tr>`,
  )
  .join("\n")}
</tbody>
</table>`
        : "",
  };
}

export function applyPlaceholders<T extends Record<string, string | null>>(
  _defaultTemplate: {
    // To provide type checking
    placeholders: T;
    placeholder_help?: T;
  },
  template: {
    title: string;
    html: string;
  },
  placeholders: T,
): { title: string; body: string } {
  function doReplace(_: string, placeholder: string): string {
    const found = placeholders[placeholder];
    if (found === undefined) {
      return placeholder;
    }
    if (found === null) {
      return "";
    }
    return found;
  }
  function doReplaceSection(
    _: string,
    placeholder: string,
    content: string,
    content_no: string | null | undefined,
  ): string {
    const found = placeholders[placeholder];
    if (found === undefined) {
      return "";
    }
    if (found === null || found === "") {
      return content_no || "";
    } else {
      return content;
    }
  }
  const title = template.title.replace(/{{(\S*)}}/g, doReplace);
  // {{#myvar}}
  // cap group
  // opt: {{!myvar}}
  // opt: cap group
  // {{/myvar}}
  const re = /{{#(\S+)}}([\s\S]+?)(?:{{\!\1}}([\s\S]+?))?{{\/\1}}/g;
  const body = template.html
    .replace(re, doReplaceSection)
    .replace(re, doReplaceSection)
    .replace(re, doReplaceSection)
    .replace(re, doReplaceSection)
    .replace(re, doReplaceSection)
    .replace(/\n\w*\n/g, "\n")
    .replace(/{{(\S+?)}}/g, doReplace);
  return { title, body };
}

export async function prepareReply(
  db: connection,
  opts: {
    schoolurl: schoolurl;
    to:
      | { tag: "teacher"; email: string; teacher_id: teacherid }
      | { tag: "student"; email: string; student_id: studentid }
      | { tag: "admin"; email: string };
    authorName: string;
    origin:
      | { tag: "message"; messageid: messageid }
      | { tag: "filenote"; lessonid: lessonid }
      | { tag: "textnote"; lessonid: lessonid; textnoteid: textnoteid };
  },
): Promise<{ replyTo: string }> {
  const { secret, replyid } = await (async () => {
    const secret = Math.floor(Math.random() * 100_000_000_000).toString();
    if (opts.origin.tag === "message") {
      const replyid: replyid = await get_next_reply_id(db, {}).then(
        (r) => r as replyid,
      );
      await message_repliesformessages.insert(db, {
        replyid: replyid,
        replyidstring: replyid.toString(),
        messageid: opts.origin.messageid,
        secret: secret,
        toadmin: opts.to.tag === "admin",
      });
      return { secret, replyid };
    } else {
      const existing = await find_note_reply(db, {
        lesson_id: opts.origin.lessonid,
        student_id: opts.to.tag === "student" ? opts.to.student_id : null,
        teacher_id: opts.to.tag === "teacher" ? opts.to.teacher_id : null,
        admin_: opts.to.tag === "admin",
      });
      if (existing) {
        return { secret: existing.secret, replyid: existing.replyid };
      } else {
        const replyid: replyid = await get_next_reply_id(db, {}).then(
          (r) => r as replyid,
        );
        await note_repliesfornotes.insert(db, {
          replyid: replyid,
          replyidstring: replyid.toString(),
          lessonid: opts.origin.lessonid,
          studentid: opts.to.tag === "student" ? opts.to.student_id : null,
          teacherid: opts.to.tag === "teacher" ? opts.to.teacher_id : null,
          admin: opts.to.tag === "admin",
          secret,
          textnoteid:
            opts.origin.tag === "textnote" ? opts.origin.textnoteid : null,
        });
        return { secret, replyid };
      }
    }
  })();
  const origMarker = opts.origin.tag === "message" ? "message" : "note";
  const replyToEmailAddress = makeReplyToAddress(
    opts.schoolurl,
    origMarker,
    replyid,
    secret,
  );
  return { replyTo: `${opts.authorName} <${replyToEmailAddress}>` };
}

export function makeReplyToAddress(
  schoolurl: schoolurl,
  origMarker: "message" | "note",
  replyid: replyid,
  secret: string,
): string {
  const schoolurlstripped = stripHttpHttps(schoolurl);
  return `${schoolurlstripped}|${origMarker}|${replyid}|${secret}@mg.classy.school`;
}

export function parseReplyToAddress(s: string): {
  origin: "note" | "message";
  replyIdString: string;
  secret: string;
} | null {
  const trimmed = s.substring(
    0,
    s.length - 17 /* length of @mg.classy.school */,
  );
  const splitted = trimmed.split("|");
  if (splitted.length === 4) {
    const origin = splitted[1];
    const replyIdString = splitted[2];
    const secret = splitted[3];
    if (origin === "note" || origin === "message") {
      return {
        origin,
        replyIdString,
        secret,
      };
    }
  }
  return null;
}

function notNullF<T, DB, ARGS>(
  f: (db: DB, args: ARGS) => Promise<T | null>,
): (db: DB, args: ARGS) => Promise<T> {
  return (db, args) =>
    f(db, args).then((res) => {
      if (res === null) {
        throw new Error(
          `Result of ${f.name} was null, args: ${JSON.stringify(args)}`,
        );
      } else {
        return res;
      }
    });
}

export function stringToJsx(html: string): HTMLElement {
  const parsed = parseStringToHyperscriptServerside(html);

  return h("div", {}, ...parsed);
}

// 'html-element' package doesn't support innerText
// it does support textContent but that spits out <style> text as well
export function getInnerTextServerside(h: HTMLElement): string {
  // remove triple or more newlines
  return getInnerTextServersideImpl(h, null)
    .split("\n")
    .reduce((acc, line) => {
      if (line === "") {
        if (acc[acc.length - 1] === "\n" && acc[acc.length - 2] === "\n") {
          return acc;
        }
      }
      acc += line + "\n";
      return acc;
    }, "")
    .trim();
}

function getInnerTextServersideImpl(
  h: HTMLElement | { textContent: string },
  parent: HTMLElement | null,
): string {
  let s = "";
  if (
    "getAttribute" in h &&
    h.getAttribute("data-remove-from-inner-text") === "true"
  ) {
    return "";
  }
  if ("tagName" in h && (h.tagName === "style" || h.tagName === "comment")) {
    return "";
  }
  if ("childNodes" in h) {
    if (h.tagName === "a" || h.tagName === "b") {
      s += " ";
    }
    if (h.tagName === "li") {
      s += "* ";
    }
    h.childNodes.forEach(
      (c) => (s += getInnerTextServersideImpl(c as HTMLElement, h)),
    );
    if (h.tagName === "a" && "href" in h) {
      const href = (h as HTMLLinkElement).href;
      s += href ? ` (${href}) ` : "";
    }
    if (h.tagName === "div") {
      s += "\n";
    }
    if (
      h.tagName === "p" ||
      h.tagName === "section" ||
      h.tagName === "article" ||
      h.tagName[0] === "h" ||
      h.tagName === "button" ||
      h.tagName === "table" ||
      h.tagName === "ul"
    ) {
      s += "\n\n";
    }
    if (h.tagName === "li") {
      s += "\n";
    }
    if (h.tagName === "br") {
      s += "\n";
    }
    if (h.tagName === "td") {
      s += "  ";
    }
    if (h.tagName === "tr") {
      s += "\n";
    }
    return s;
  } else if ("textContent" in h) {
    if (parent && parent.getAttribute("style")?.includes("pre")) {
      return (h.textContent || "").trim();
    } else {
      s = (h.textContent || "").replace(/\n/g, "").trim();
      if (parent && parent.tagName === "b") {
        s += " ";
      }
      return s;
    }
  } else {
    return "";
  }
}

export function queuedMessageTagToMessageTemplateType(
  tag: queueableEmail["tag"] | noteOrMessage["tag"],
  enrollment_formula_type: formulaType | null,
): messagetemplatetype {
  if (
    tag === "EnrollmentCreatedByAdmin" ||
    tag === "EnrollmentRequestApproved"
  ) {
    if (enrollment_formula_type === null) {
      return "EnrollmentCreatedPrivate";
    }
    return enrollment_formula_type.tag === "Private"
      ? "EnrollmentCreatedPrivate"
      : enrollment_formula_type.tag === "Group"
      ? "EnrollmentCreatedGroup"
      : enrollment_formula_type.tag === "Camp"
      ? "EnrollmentCreatedCamp"
      : checkAllCasesHandled(enrollment_formula_type);
  } else {
    return tag;
  }
}

export async function queuedMessageToMessageTemplateTypeAsync(
  db: connection,
  q: queueableEmail | noteOrMessage,
): Promise<messagetemplatetype> {
  if (
    q.tag === "EnrollmentCreatedByAdmin" ||
    q.tag === "EnrollmentRequestApproved"
  ) {
    const lg = await get_lessongroup_for_enrollment(db, {
      enrollment_id: q.enrollmentId,
    });
    if (!lg) {
      throw new Error(`Lessongroup not found for enrollment ${q.enrollmentId}`);
    }
    return queuedMessageTagToMessageTemplateType(
      q.tag,
      parseFormulaType(lg.type_),
    );
  } else {
    return queuedMessageTagToMessageTemplateType(q.tag, null);
  }
}
export function renderSchoolInvoiceDetailsForEmail(
  opts: { schoolname: string },
  det: {
    vat: string | null;
    address: string | null;
    extra: string | null;
  },
): string {
  const vat = det.vat?.trim() || null;
  const addr = det.address?.trim() || null;
  const extra = det.extra?.trim() || null;
  if (isNil(vat) && isNil(addr) && isNil(extra)) {
    return "";
  } else {
    return (
      `<div>${opts.schoolname}</div>` +
      (vat ? `<div>${vat}</div>` : "") +
      (addr ? `<div>${addr}</div>` : "") +
      (extra ? `<div>${extra}</div>` : "")
    );
  }
}
